import type { OrchestratedStepKind } from '@axilon-apps/domains-ontology-ui-state'

/**
 * Title-case display label for each plan-step agent, shown in the chat
 * transcript step headers and tool-call chips (both CSS-uppercase the text,
 * so "Query" renders as "QUERY").
 */
export const AGENT_LABELS: Record<OrchestratedStepKind, string> = {
  query_agent: 'Query',
  notification_rules_builder: 'Notification Rules',
  custom_agent_builder: 'Custom Agent',
  ingest_agent: 'Ingest',
  dashboard_builder: 'Dashboard',
  documents_agent: 'Documents', // Historical conversation steps only.
  integrations_agent: 'Integration',
  ingest_query_agent: 'Ingest Q&A',
  text: 'Text'
}

export function agentLabel(kind: string): string {
  return AGENT_LABELS[kind as OrchestratedStepKind] ?? kind
}

export function agentShortLabel(kind: string): string {
  if (kind === 'agent_orchestrator') return 'orch'
  return agentLabel(kind)
}
